import {isEqual, isFunction} from 'lodash';
import {useEffect} from 'react';
import {useUpdate} from 'react-use';

export const createStore = <T = unknown>(initial: T) => new GlobalStore(initial);

export class GlobalStore<T = unknown> {
  protected _state: T;
  protected _initial: T;
  protected _listeners = [] as Array<() => void>;

  constructor(initial: T) {
    this._state = initial;
    this._initial = initial;
  }

  get() {
    return this._state;
  }

  set = (newState: T | ((currentState: T) => T)) => {
    if (isFunction(newState)) {
      newState = newState(this.get());
    }
    if (!isEqual(this.get(), newState)) {
      this._state = newState;
      this.notify();
    }
  }

  reset() {
    this.set(this._initial);
  }

  subscribe(callback: () => void) {
    this._listeners.push(callback);
    return () => {
      this._listeners.splice(this._listeners.indexOf(callback), 1);
    };
  }

  notify() {
    this._listeners.forEach((listener) => listener());
  }

  initial() {
    return this._initial;
  }

  useState () {
    const update = useUpdate();
    useEffect(() => this.subscribe(update), []);
    return [
      this.get(),
      this.set
    ] as const;
  }
}
